import styled, { css } from 'styled-components';
import { Pill } from 'src/components';

export const PricesCard = styled.button<{
  $selected: boolean;
}>(
  ({ theme, $selected }) => css`
    background: ${theme.co.neutral99};
    cursor: pointer;
    padding: ${theme.sz.s4};
    position: relative;
    border-radius: ${theme.sz.s3};
    border: 3px solid ${theme.co.secondary90};
    display: flex;
    flex-direction: column;
    width: 100%;

    &:hover {
      border-color: ${theme.co.secondary50};
      background: ${!$selected && theme.co.neutral98};
      opacity: ${$selected && '0.9'};
    }

    ${
      $selected &&
      css`
        border-color: ${theme.co.primary20};

        &:hover {
          border-color: ${theme.co.primary20};
        }
      `
    };

    button {
      color: ${$selected && theme.co.neutral99};
    }
  `,
);

export const Period = styled.p(
  ({ theme }) => css`
    text-align: left;
    ${theme.typography.heading.mobile.xs};
    margin: 0;
  `,
);

export const Badge = styled(Pill)(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    position: absolute;
    background: linear-gradient(180deg, ${theme.co.primary20} 43.92%, ${theme.co.warning50} 100%);
    right: ${theme.sz.s4};
    top: -${theme.sz.s3};
    text-transform: none;
  `,
);

export const PriceWrapper = styled.div(
  () => css`
    display: flex;
    align-items: baseline;
  `,
);

export const RowWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: space-between;
    flex-wrap: wrap;
    column-gap: ${theme.sz.s2};
  `,
);

export const Price = styled.p(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.s};
    margin: 0;
    padding-right: ${theme.sz.s05};
  `,
);

export const PerPeriod = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
  `,
);

export const PriceBeforeSale = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary20};
    ${theme.typography.paragraph.base};
    text-decoration: line-through;
  `,
);

export const PricePerMonth = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.secondary20};
  `,
);
